import { createContext, useContext } from 'react';

const measurementSystemContext = createContext(null);

export const useMeasurementSystem = () => useContext(measurementSystemContext);

export const MeasurementSystemProvider = measurementSystemContext.Provider;
